import React from "react";
import Appbar from "./Appbar";
import Sidebar from "./Sidebar";
import { Outlet } from "react-router-dom";
import Footer from "./Footer";

const PageLayout = () => {
  return (
    <div id="wrapper" class="wrapper bg-ash">
      <Appbar />
      <div className="dashboard-page-one">
        <Sidebar />
        <div class="dashboard-content-one">
          <Outlet />
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default PageLayout;
